// 全局loading组件
<template>
  <div class="g-loading" v-show="loading">
  <!--<div class="m-loading1">
    <div class="spinner">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
    </div>
  </div>-->
  <div class="m-loading2">
    <div class="spinner">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
    </div>
     <p class="u-jump-info">请稍候，正在跳转...</p>
  </div>
</div>
</template>

<script>
export default{
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
$bg_blue : #2c82ff; //大背景色
 .m-loading2{
        position: relative;
        top: 30%;
        text-align: center;
        .u-jump-info{
            font-weight: 600;
            margin-top: 15px;
            font-size: 17px;
        }
    }
  .m-loading2{
    .spinner {
        margin: 0 auto;
        width: 50px;
        height: 30px;
        padding: 15px 0;
        text-align: center;
        font-size: 10px;
    }

    .spinner > div {
        background-color: $bg_blue;
        height: 100%;
        width: 6px;
        display: inline-block;

        -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
        animation: stretchdelay 1.2s infinite ease-in-out;
    }

    .spinner .rect2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
    }

    .spinner .rect3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }

    .spinner .rect4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
    }

    .spinner .rect5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
    }

    @-webkit-keyframes stretchdelay {
        0%, 40%, 100% { -webkit-transform: scaleY(1) }
        20% { -webkit-transform: scaleY(2.0) }
    }

    @keyframes stretchdelay {
        0%, 40%, 100% { transform: scaleY(1) }
        20% { transform: scaleY(2.0) }
    }
}
</style>



// WEBPACK FOOTER //
// jumploading.vue?0a3c3212